import clsx from 'clsx';
import React from 'react';
import { useResponsiveProp } from '../../utils';
import { useTableContext } from './TableContext';
export function TableCell(props) {
    const { children, className, align, alignSelf, numeric, overflow, gridArea, style, hidden, ...rest } = props;
    const { selectable: tableSelectable } = useTableContext();
    const responsiveAlign = useResponsiveProp(align);
    return (React.createElement("td", { ...rest, className: clsx('mollie-ui-table-cell', {
            [`mollie-ui-table-cell--align-${responsiveAlign}`]: responsiveAlign,
            'mollie-ui-table-cell--numeric': numeric,
        }, className), role: tableSelectable ? 'gridcell' : 'cell', style: {
            ...style,
            gridArea: useResponsiveProp(gridArea),
            alignSelf: useResponsiveProp(alignSelf),
        }, hidden: useResponsiveProp(hidden) }, useResponsiveProp(overflow) ? (React.createElement("div", { className: "mollie-ui-table-cell-overflow" }, children)) : (children)));
}
TableCell.displayName = 'Table.Cell';
//# sourceMappingURL=TableCell.js.map